
import axios from "@/axios.js"

export default {
  fetchItems({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get("/quotes")
        .then((response) => {
          commit('SET_ITEMS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  getItem(_, id) {
    return new Promise((resolve, reject) => {
      axios.get(`/quote/${id}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  addItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post("/quote", item)
        .then((response) => {
          // commit('ADD_ITEM', Object.assign(response.data.quote, {id: response.data.quote.id}))
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateItem({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/quote/${item.id}`, item)
        .then((response) => {
          // commit('UPDATE_ITEM', response.data.quote)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  updateStatus({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.put(`/quote/${item.id}/status`, {status: item.status})
        .then((response) => {
          commit('UPDATE_ITEM_STATUS', {id: item.id, status: item.status})
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  
  updateModeReglement({ commit }, item) {
    console.log("action:",item)
    return new Promise((resolve, reject) => {
      axios.put(`/quote/${item.id}/modeReglement`, {modeReglement: item.value})
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },

  removeItem({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.delete(`/quote/${itemId}`)
        .then((response) => {
          // commit('REMOVE_ITEM', itemId)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },




}
